<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-11-03 17:10:00
 * @LastEditors: liushuaibo liushuaibo@yangxuan.net
 * @LastEditTime: 2022-12-07 17:28:59
-->
<template>
	<div>
		<el-dialog title="提示" :visible.sync="visible" width="400px" @close="handleClose">
			<div class="tip">
				<p class="font-h4-regular yx-color-text-primary flex-row">
					<i class="el-icon-warning font-h1-regular"></i>
					<span class="ml-10"> 账号手机更换后，将继承原绑定的微信。如需换绑微信，请手动解绑。确认是否继续操作？ </span>
				</p>
				<p class="font-h4-regular yx-color-text-primary ml-28 mt-20">微信【{{ wxNickName }}】 已绑原手机号{{ oldMobile }}</p>
			</div>
			<span slot="footer">
				<el-button @click="handleClose">取消</el-button>
				<el-button type="primary" @click="confirm">确认</el-button>
			</span>
		</el-dialog>
	</div>
</template>
<script>
export default {
	data() {
		return {
			visible: false,
			wxNickName: '',
			oldMobile: '',
		};
	},
	methods: {
		show(wxNickName = [], oldMobile = '') {
			this.wxNickName = wxNickName;
			this.oldMobile = oldMobile;
			this.visible = true;
		},
		confirm() {
			this.$emit('refresh');
			this.handleClose();
		},
		handleClose() {
			this.visible = false;
			this.wxNickName = [];
			this.oldMobile = '';
		},
	},
};
</script>
<style lang="less" scoped>
.tip {
	i {
		color: @color-warning;
		position: relative;
		top: 2px;
	}
}
</style>
